import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=3dbe2d8a&scoped=true"
import script from "./relations.vue?vue&type=script&lang=ts"
export * from "./relations.vue?vue&type=script&lang=ts"
import style0 from "./relations.vue?vue&type=style&index=0&id=3dbe2d8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe2d8a",
  null
  
)

export default component.exports